import moment from "moment";

export const HAKLAI_INHERITANCE_TESTATOR_BASIS_START_DATE = "1981-04-01";

export const normalizeHaklaiDateKey = (date) => {
  if (!date) return "";
  const parsedDate = date instanceof Date
    ? moment(date)
    : moment(String(date), ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);
  return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
};

export const getHaklaiCurrencyConversionDate = (preCalc = {}) => {
  const acquisitionDetails = preCalc.acquisitionDetails || {};
  if (preCalc.wayOfGettingProperty === "inheritance") {
    const passingDate = normalizeHaklaiDateKey(acquisitionDetails.testatorPassingDate);
    if (
      passingDate
      && moment(passingDate, "YYYY-MM-DD", true).isSameOrAfter(
        moment(HAKLAI_INHERITANCE_TESTATOR_BASIS_START_DATE, "YYYY-MM-DD", true),
        "day"
      )
    ) {
      return normalizeHaklaiDateKey(acquisitionDetails.testatorBoughtPropertyDate);
    }
    return passingDate;
  }
  return normalizeHaklaiDateKey(acquisitionDetails.deduDate);
};

export const convertHaklaiLocalCurrencyToShekel = (amount, currency = "newShekel") => {
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount) || numericAmount <= 0) return null;
  if (currency === "lira") return numericAmount / 10000;
  if (currency === "oldShekel") return numericAmount / 1000;
  return numericAmount;
};

export const parseHaklaiUsdRate = (response) => {
  if (!response || response.err) return null;
  const rate = Number(response);
  return Number.isFinite(rate) && rate > 0 ? rate : null;
};

export const calculateHaklaiAcquisitionCostInShekel = ({
  amount,
  currency,
  conversionDate,
  usdRate
}) => {
  if (currency !== "usd") {
    return convertHaklaiLocalCurrencyToShekel(amount, currency || "newShekel");
  }

  const numericAmount = Number(amount);
  const numericRate = Number(usdRate);
  if (
    !Number.isFinite(numericAmount)
    || numericAmount <= 0
    || !conversionDate
    || !Number.isFinite(numericRate)
    || numericRate <= 0
  ) {
    return null;
  }

  return Math.round(numericAmount * numericRate);
};
